import { BaseController } from 'controllers/BaseController'
import {
  IAnalyticsAPI,
  KpiFilterAndTargetConfiguration,
  KPI,
} from './SalesLeadTimeController'
import moment from 'moment'
import { AnalyticsAPI } from './AnalyticsAPI'
import { QuantityDto } from 'services/APIs/InternalAPI/internal-api.contracts'

export class ConversionRateController extends BaseController<IAnalyticsAPI> {
  constructor(private partyId, private targetValue: number) {
    super((onRequestCallback) => new AnalyticsAPI(onRequestCallback))
  }

  private data: number

  private _configuration: KpiFilterAndTargetConfiguration

  public async SetTargetConfiguration(
    kpi: KPI,
    value: QuantityDto
  ): Promise<void> {
    if (!value?.value) return

    await this.api.SetKPITarget(this.partyId, kpi, value)

    this._configuration = {
      ...this._configuration,
      ...value,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any
  }

  public GetConfiguration() {
    if (!this._configuration) {
      this._configuration = {
        startDate: moment()
          .subtract(1, 'month')
          .hours(0)
          .minutes(0)
          .seconds(0)
          .milliseconds(0)
          .toDate(),

        endDate: moment()
          .hours(0)
          .minutes(0)
          .seconds(0)
          .milliseconds(0)
          .toDate(),

        unit: '%',
        value: this.targetValue,
      }
    }

    return this._configuration
  }

  public SetConfiguration(configuration: KpiFilterAndTargetConfiguration) {
    this._configuration = configuration
  }

  public async GetConversionRateData() {
    this.data = (
      await this.api.GetConversionRate(
        this.partyId,
        moment(this._configuration.startDate).toISOString(),
        moment(this._configuration.endDate).toISOString()
      )
    )?.conversion_rate

    return this.data
  }
}
